import { round2 } from './utils.js';

export function maxDispensingFee(sep) {
  if (sep < 118.8)   return round2(15.8   + 0.46 * sep);
  if (sep < 315.53)  return round2(30.24  + 0.33 * sep);
  if (sep < 1104.4)  return round2(86.11  + 0.15 * sep);
  return round2(198.36 + 0.05 * sep);
}

export function minDispensingFee(sep) {
  if (sep < 118.8)  return 15.80;
  if (sep < 315.53) return 30.24;
  if (sep < 1104.4) return 86.11;
  return 198.36;
}

export async function searchMedicine(q) {
  const enc = encodeURIComponent(q.trim());
  const res = await fetch(`/api/search?q=${enc}`);
  if (!res.ok) throw new Error('Search failed');
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}
